import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum TransactionType {
	BUY_SERVICE = 1,
	SELL_SERVICE = 2,
	EXCHANG_ESERVICE = 3,
	DEPOSIT = 4,
	WITHDRAWAL = 5,
	BETWEEN_MY_WALLETS = 8,
	INTERNAL_TRANSFER = 9,
	CHARGE_SMS_PANEL = 10,
	WITHDRAWAL_POINT = 11,
	VOUCHER_SERVICE = 12,
	TC_PAY_GATEWAY = 14,
	WalletCorrectionRequest = 15,
	PointCorrectionRequest = 16,
	Transition = 17,
	TerminalSettlement = 18,
	BrokerDeposit = 19,
	DirectDeposit = 20,
	LOCK_WALLET = 21,
	UNLOCK_WALLET = 22,
	P2P_INTERNAL_TRANSFER = 23,
	P2P_PENALTY = 24,
	AffiliateProgram = 25,
	P2PCommission = 26,
	CryptoDeposit = 27,
	CryptoWithdrawal = 28,
}


export namespace TransactionType {

	export function getTitle(type: TransactionType): string {
		return Object.keys(TransactionType).find(key => TransactionType[key] === type);
	}

}

@Pipe({
	name: 'transactionTypeText',
	standalone: true
})
export class TransactionTypePipe implements PipeTransform {

	transactionType = TransactionType;
	translatedText: string;

	constructor(private translateService: TranslateService) {
	}

	transform(value: TransactionType): any {
		this.getTranslate(
			this.transactionType.getTitle(value)
		);

		return this.translatedText;
	}

	getTranslate(text: string) {
		text = 'ENUM.TRANSACTION_TYPES.' + text;
		this.translateService.get(text).subscribe(res => {
			this.translatedText = res;
		});
	}
}